<template>
  <div class="ml-auto mr-2">
    <label for="languageSelection" class="sr-only">{{ $t('HomePage.selectLanguage') }}</label>
    <select v-model="selectedLanguage" class="custom-select custom-select-translucent mt-3"
            id="languageSelection">
      <option v-for="(language, index) in languages"
              :key="index" :value="language.code">{{ language.shortName }}
      </option>
    </select>
  </div>
</template>

<script>

import LocaleMixin from '@shared/mixins/LocaleMixin'
import { languagesList as languages } from '@/i18n/languages'

export default {
  name: 'LanguageSelector',
  mixins: [LocaleMixin],
  data() {
    return {
      selectedLanguage: this.getLanguage(),
      languages: languages
    }
  },
  watch: {
    selectedLanguage(language) {
      this.setLanguage(language)
    }
  }
}
</script>
